import { useEffect, useState } from 'react';

import { readRecoveryTokenHash } from '@/utils/recoveryTokens';

const readInitialTokenHash = () => readRecoveryTokenHash(window.location.search);

const useRecoverySession = () => {
  const [tokenHash] = useState(readInitialTokenHash);

  useEffect(() => {
    if (tokenHash) {
      window.history.replaceState(null, '', window.location.pathname);
    }
  }, [tokenHash]);

  return { tokenHash };
};

export {
  useRecoverySession,
};
